<h1 class='display-1 text-center'>Current weather for {{city | titlecase}}</h1>
<mat-tab-group mat-align-tabs='start'>
    <mat-tab label='Temprature'>
        <div class='table-responsive'>
            <table class='table table-hover'>
                <thead>
                    <tr>
                        <th>Serial No.</th>
                        <th>Temprature Parameters</th>
                        <th>Temprature Value(&deg;C) </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Current Temprature</td>
                        <td>{{tempInF.temp}}</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Maximum Temprature</td>
                        <td>{{tempInF.temp_max}}</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Minimum Temprature</td>
                        <td>  {{tempInF.temp_min}}</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Actual Feel Temprature</td>
                        <td>{{tempInF.feels_like}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-tab>

    <mat-tab label='Weather Details'>
        <table class='table table-hover'>
            <thead>
                <tr>
                    <th>Serial No.</th>
                    <th>Weather Parameters</th>
                    <th>Values</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Pressure</td>
                    <td>{{this.dataComing?.main.pressure}} hpa</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Humidity</td>
                    <td>{{this.dataComing?.main.humidity}}%</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>Present Weather</td>
                    <td>{{this.dataComing?.weather[0].main}}</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>Description</td>
                    <td>{{this.dataComing?.weather[0].description}}</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>Cloudiness</td>
                    <td>{{this.dataComing?.clouds.all}}%</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>Wind Speed</td>
                    <td>{{this.dataComing?.wind.speed}} m/s</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>Visibility</td>
                    <td>{{this.dataComing?.visibility/1000}} km</td>
                </tr>
            </tbody>

        </table>
    </mat-tab>
    <mat-tab label='Geographical Details'>
        <table class='table table-hover'>
            <thead>
                <tr>
                    <th>Serial No.</th>
                    <th>Geographical Parameters</th>
                    <th>Estimated Values</th>
                </tr>           
             </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>City Name</td>
                        <td>{{this.dataComing?.name}}</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Country Name</td>
                        <td>{{this.dataComing?.sys.country}}</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Sun Rise Time</td>
                        <td>{{timeInRead.sunrise}}</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Sun Set Time</td>
                        <td>{{timeInRead.sunset}}</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Time of Data Calculation</td>
                        <td>{{timeInRead.timezone}}</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>City Geographical Location, longitude</td>
                        <td>{{this.dataComing?.coord.lat}}</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>City Geographical Location, latitude</td>
                        <td>{{this.dataComing?.coord.lon}}</td>
                    </tr>

                </tbody>
        </table>
    </mat-tab>
</mat-tab-group>